import { render } from "./BlogsPage.vue?vue&type=template&id=c179fcea"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__